import { normalize, schema, denormalize } from 'normalizr';

const ticketStatus = new schema.Entity(
  'ticketStatuses',
  {},
  { idAttribute: 'id' }
);

export function normalizeDatos(myData) {
  const mySchema = { ticketStatus: [ticketStatus] };
  const normalizedData = normalize(myData, mySchema);
  return normalizedData;
}

export function normalizeDato(myData) {
  const mySchema = ticketStatus;
  const normalizedData = normalize(myData, mySchema);

  return normalizedData;
}

export function denormalizeDato(myData, store) {
  const mySchema = ticketStatus;

  const normalizedData = denormalize(myData, mySchema, store);

  return normalizedData;
}

export default ticketStatus;
